<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Body 1/Bold'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126909&m=dev'
*/

defineOptions({
  name: 'TextPrimaryMedium',
})

withDefaults(defineProps<TextPrimaryMediumProps>(), {
  is: 'div',
})

interface TextPrimaryMediumProps {
  is?: 'div' | 'p' | 'span'
}
</script>

<template>
  <component
    :is="is"
    class="p-text-primary-medium"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="./TextPrimaryMedium.scss" />
